import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {AuthService} from '../service/auth.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import $ from 'jquery';
import {DomSanitizer} from '@angular/platform-browser';
import {user_accessInterface, SharedService} from '../service/shared.service';


@Component({
    selector: 'app-grow-halfhalf',
    templateUrl: './grow-halfhalf.component.html',
    styleUrls: ['./grow-halfhalf.component.css']
})
export class GrowHalfhalfComponent implements OnInit {
    @Input() id: any;
    @Input() main_color_value: any;
    @Input() user_access: user_accessInterface;
    @Input() heading_font_color: any;
    @Input() title_color: any;
    @Input() is_service_note: any
    @Output() result = new EventEmitter<any>()
    @Output() upload = new EventEmitter<any>()
    @Output() notes = new EventEmitter<any>()
    @Output() completechapter = new EventEmitter<any>()
    @Output() assignment = new EventEmitter<any>()
    @Output() notesicon = new EventEmitter<any>()
    @Output() page_id = new EventEmitter<any>()

    api = environment.apiEndpoint;
    imgurl = environment.imageurl;
    tokenvalue: string;
    pagedata: any;
    halfhalfdata: any;
    color: any;
    brandname: any;
    full_title: any;
    left_column: any;
    right_column: any;
    visual_position: any;
    visualimage: any;
    main_color: any;
    bacgrdimage: any;
    backgrd_position: any;
    forbackimg: any;
    backgrdimagposition: any;
    showassignment: boolean = false;
    allow_upload: any;
    assign_type: any;
    learninggoals: any[] = [];
    assignmentdata: any;
    teamdata: any[] = [];
    teamsvalue: any[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'];
    pageheader_image: any;
    assignmentid: any;
    user_slug: string;
    teamid: any = 0;
    assignment_name: any;
    subtitle: any;
    notification: any = '0';
    main_font: string;
    second_font: string;
    bullet_back_src: string;
    bullet_position_top = 8;
    link_back_src: string;
    check_bac_src: string;
    pc_title_left: any;
    service_enforce: any = 0;
    complete_chapter: any;
    visual_image: any;
    fk_brand_id: string;


    constructor(public authservice: AuthService, private ar: ActivatedRoute, private httpclient: HttpClient, private domSanitizer: DomSanitizer, private shareservice: SharedService) {
        Window["myComponent"] = this;      //for innerhtml click event
    }

    ngOnInit() {
        // $("#Content").removeClass("min-height-page");
        $("#Content").css("min-height", "0px");

        this.fk_brand_id = localStorage.getItem("fk_brand_id")
        if (this.id) {
            this.gethalfhalfdata(this.id);
        }
        this.main_color = this.main_color_value
        this.user_slug = localStorage.getItem('user_slug')
    }

    gethalfhalfdata(id) {
        this.tokenvalue = localStorage.getItem('auth-token');
        this.httpclient.get(this.api + "auth/pagesingledata?id=" + id + "&token=" + this.tokenvalue).subscribe((data: halfhalfdata) => {
            this.halfhalfdata = data.differentpage;
            this.pagedata = data.page;
            this.notification = data.notification
            this.pc_title_left = this.halfhalfdata.pc_title_left
            this.full_title = this.pagedata['page_title'];
            this.color = this.pagedata['chaptercolor'];
            this.brandname = this.pagedata['brandname'];
            this.pageheader_image = this.pagedata.header_thumbnail
            this.page_id.emit({pid: this.pagedata.id});
            console.log('pc_title_left', this.pc_title_left)
            console.log('brand_name', this.brandname)

            if (localStorage.getItem('service_enforce') == '1') {
                this.complete_chapter = this.pagedata.complete_chapter
                this.service_enforce = localStorage.getItem('service_enforce')
                this.completechapter.emit(this.complete_chapter)

            }

            //ol li::before margin-left :-1em changed to 0 em  and padding 0px
            //this.left_column = this.domSanitizer.bypassSecurityTrustHtml(this.halfhalfdata['lc_introduction']+'<style>#subcontent h1,h2,h3,h4,h5,h6{color:'+this.main_color+'!important} #subcontent ul {list-style-type: none;} ol {list-style-type:none} ul {padding-left: 15px;}  ol {padding:0px} #subcontent ul li::before {content: "•";color:'+this.main_color+'!important;font-weight: bold;display: inline-block;width: 1em;margin-left: -1em;} #subcontent ol  li::before {content: counter(li); color: '+this.main_color+'!important; display: inline-block; width: 1em; margin-left: 0em ;font-size:32px; } #subcontent ol li {counter-increment: li}</style>');
            //this.right_column = this.domSanitizer.bypassSecurityTrustHtml(this.halfhalfdata['rc_introduction']+'<style>#maincontent h1,h2,h3,h4,h5,h6{color:'+this.main_color+'!important} #assignment ul {padding-left: 15px;} #assignment ul  li::before {content: "•";color:'+this.main_color+'!important;font-weight: bold;display: inline-block;width: 1em;margin-left: -1em;} #maincontent ul {list-style-type: none;} ol {list-style-type:none} ol {padding-left:0px;} ul {padding-left: 15px;} #maincontent ul  li::before {content: "•";color:'+this.main_color+'!important;font-weight: bold;display: inline-block;width: 1em;margin-left: -1em;} #maincontent ol  li::before {content: counter(li); color: '+this.main_color+'!important; display: inline-block; width: 1em; margin-left: 0em !important;font-size:32px; } #maincontent ol li {counter-increment: li}   </style>');

            if (this.brandname == 'park') {
                this.main_font = "SilkaMono";
                this.second_font = "'Roboto', sans-serif";
                this.bullet_position_top = 7;
                if (this.color == 'blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Park/bullet-park-academy-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Park/external-park-academy-blue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Park/check-park-academy-blue.svg"
                }
                if (this.color == 'green') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Park/bullet-park-academy-green.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Park/external-park-academy-green.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Park/check-park-academy-green.svg"
                }
                if (this.color == 'yellow') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Park/bullet-park-academy-yellow.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Park/external-park-academy-yellow.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Park/check-park-academy-yellow.svg"
                }
                if (this.color == 'red') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Park/bullet-park-academy-red.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Park/external-park-academy-red.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Park/check-park-academy-red.svg"
                }
                if (this.color == 'gray') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Park/bullet-park-academy-gray.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Park/external-park-academy-gray.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Park/check-park-academy-gray.svg"
                }
            }
            if (this.brandname == 'grow') {
                this.main_font = "'Museo W01 500', HelveticaNeue, Helvetica";
                this.second_font = "'Calibri W01 Regular 904604', Arial, HelveticaNeue, Helvetica, Geneva, sans-serif";
                console.log('this.color', this.color);
                if (this.color == 'warm red') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Grow/bullet-grow-warm-red";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Grow/external-grow-warm-red.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Grow/check-grow-warm-red.svg"
                }

                if (this.color == 'blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Grow/bullet-grow-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Grow/external-grow-blue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Grow/check-grow-blue.svg"
                }
                if (this.color == 'purple') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Grow/bullet-grow-purple.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Grow/external-grow-purple.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Grow/check-grow-purple.svg"
                }
                if (this.color == 'orange') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Grow/bullet-grow-orange.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Grow/external-grow-orange.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Grow/check-grow-orange.svg"
                }
                if (this.color == 'red') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Grow/bullet-grow-red.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Grow/external-grow-red.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Grow/check-grow-red.svg"
                }
                if (this.color == 'green') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Grow/bullet-grow-green.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Grow/external-grow-green.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Grow/check-grow-green.svg"
                }
                if (this.color == 'aqua') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Grow/bullet-grow-aqua.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Grow/external-grow-aqua.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Grow/check-grow-aqua.svg"
                }
            }

            // if(this.brandname=='draeger')
            // {
            //  this.main_font="'CotySans-Bold'";
            //  this.second_font="'Calibri W01 Regular 904604', Arial, HelveticaNeue, Helvetica, Geneva, sans-serif";
            //  if(this.color=='red')
            //  {
            //   this.bullet_back_src="./assets/img/snippet/BrandElements/draeger/bullet-draeger-red.svg";
            //   this.link_back_src="./assets/img/snippet/BrandElements/draeger/external-draeger-red.svg" //give it to <a.external> tag
            //   this.check_bac_src="./assets/img/snippet/BrandElements/draeger/check-draeger-red.svg"
            //  }
            //  if(this.color=='green')
            //  {
            //   this.bullet_back_src="./assets/img/snippet/BrandElements/draeger/bullet-draeger-green.svg";
            //   this.link_back_src="./assets/img/snippet/BrandElements/draeger/external-draeger-green.svg" //give it to <a.external> tag
            //   this.check_bac_src="./assets/img/snippet/BrandElements/draeger/check-draeger-green.svg"
            //  }
            //  if(this.color=='light-blue')
            //  {
            //   this.bullet_back_src="./assets/img/snippet/BrandElements/draeger/bullet-draeger-light-blue.svg";
            //   this.link_back_src="./assets/img/snippet/BrandElements/draeger/external-draeger-light-blue.svg" //give it to <a.external> tag
            //   this.check_bac_src="./assets/img/snippet/BrandElements/draeger/check-draeger-light-blue.svg"
            //  }
            //   if(this.color=='blue')
            //  {
            //   this.bullet_back_src="./assets/img/snippet/BrandElements/draeger/bullet-draeger-blue.svg";
            //   this.link_back_src="./assets/img/snippet/BrandElements/draeger/external-draeger-blue.svg" //give it to <a.external> tag
            //   this.check_bac_src="./assets/img/snippet/BrandElements/draeger/check-draeger-blue.svg"
            //  }
            //   if(this.color=='orange')
            //  {
            //   this.bullet_back_src="./assets/img/snippet/BrandElements/draeger/bullet-orange.svg";
            //   this.link_back_src="./assets/img/snippet/BrandElements/draeger/external-orange.svg" //give it to <a.external> tag
            //   this.check_bac_src="./assets/img/snippet/BrandElements/draeger/check-orange.svg"
            //  }


            // }
            if (this.brandname == 'drager') {
                this.main_font = "'draeger'"
                this.second_font = "'draeger2'";
                console.log(this.color)
                if (this.color == 'purple') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-purple.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-purple.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-purple.svg";


                }
                if (this.color == 'magenta') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-magenta.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-magenta.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-magenta.svg";

                }
                if (this.color == 'spruce') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-spruce.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-spruce.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-spruce.svg";


                }
                if (this.color == 'ocean') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-ocean-new.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-ocean.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-ocean.svg";

                }
                if (this.color == 'blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-blue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-blue.svg";


                }
                if (this.color == 'rose') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-rose.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-rose.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-rose.svg";

                }
                if (this.color == 'lime') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-lime.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-lime.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-lime.svg";


                }
                if (this.color == 'coral') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-coral.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-coral.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-coral.svg";


                }

            }

            if (this.brandname == 'coty') {
                this.main_font = "'CotySans-Bold'";
                this.second_font = "'Calibri W01 Regular 904604', Arial, HelveticaNeue, Helvetica, Geneva, sans-serif";
                if (this.color == 'purple') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-purple.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-purple.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-purple.svg"
                }
                if (this.color == 'yellow') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-yellow.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-yellow.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-yellow.svg"
                }
                if (this.color == 'orange') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-orange.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-orange.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-orange.svg"
                }
                if (this.color == 'magenta') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-magenta.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-magenta.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-magenta.svg"
                }
                if (this.color == 'red') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-red.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-red.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-red.svg"
                }
                if (this.color == 'light purple') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-lightpurple.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-lightpurple.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-lightpurple.svg"
                }
                if (this.color == 'dark blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-darkblue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-darkblue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-darkblue.svg"
                }
                if (this.color == 'blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-blue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-blue.svg"
                }
                if (this.color == 'aqua') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-aqua.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-aqua.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-aqua.svg"
                }
                if (this.color == 'green') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Coty/bullet-coty-green.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Coty/external-coty-green.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Coty/check-coty-green.svg"
                }
            }
            if (this.brandname == 'lego') {
                this.main_font = "CeraPro, Arial, Helvetica, sans-serif"
                this.second_font = "CeraPro, 'Calibri W01 Regular 904604', Arial, HelveticaNeue, Helvetica, Geneva, sans-serif";
                this.bullet_position_top = 3;
                if (this.color == 'medium lilac') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Lego/bullet-lego-lilac.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Lego/external-lego-lilac.svg";
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Lego/check-lego-lilac.svg";
                }
                if (this.color == 'bright blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Lego/bullet-lego-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Lego/external-lego-blue.svg";
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Lego/check-lego-blue.svg";
                }
                if (this.color == 'dark green') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Lego/bullet-lego-green.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Lego/external-lego-green.svg";
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Lego/check-lego-green.svg";
                }
                if (this.color == 'bright red') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Lego/bullet-lego-red.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Lego/external-lego-red.svg";
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Lego/check-lego-red.svg";
                }
            }
            if (this.brandname == "raymond") {
                this.main_font = "'Airstrip-Four', Arial, HelveticaNeue, Helvetica"
                this.second_font = "'Calibri W01 Regular 904604', Arial, HelveticaNeue, Helvetica, Geneva, sans-serif";
                if (this.color == 'red') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Raymond/bullet-raymond-red.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Raymond/external-raymond-red.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Raymond/check-raymond-red.svg";
                }
            }
            if (this.brandname == "gsk") {
                this.main_font = "'Arial', HelveticaNeue, Helvetica, Geneva, sans-serif"
                this.second_font = "'Arial', HelveticaNeue, Helvetica, Geneva, sans-serif";
                if (this.color == 'orange') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-orange.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-orange.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-orange.svg"
                }
                if (this.color == 'light orange') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-lightorange.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-lightorange.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-lightorange.svg"
                }
                if (this.color == 'aqua') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-aqua.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-aqua.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-aqua.svg"
                }
                if (this.color == 'green') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-green.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-green.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-green.svg"
                }
                if (this.color == 'blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-blue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-blue.svg"
                }
                if (this.color == 'red') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-red.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-red.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-red.svg"
                }
                if (this.color == 'purple') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-purple.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-purple.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-purple.svg"
                }
                if (this.color == 'brown') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-brown.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-brown.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-brown.svg"
                }
                if (this.color == 'beige') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-beige.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-beige.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-beige.svg"
                }
                if (this.color == 'light') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Gsk/bullet-gsk-light.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Gsk/external-gsk-light.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Gsk/check-gsk-light.svg"
                }
            }
            if (this.brandname == 'drager') {
                this.main_font = "'draeger'"
                this.second_font = "'draeger2'";
                console.log(this.color)
                if (this.color == 'purple') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-purple.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-purple.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-purple.svg";


                }
                if (this.color == 'magenta') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-magenta.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-magenta.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-magenta.svg";

                }
                if (this.color == 'spruce') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-spruce.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-spruce.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-spruce.svg";


                }
                if (this.color == 'ocean') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-ocean.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-ocean.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-ocean.svg";

                }
                if (this.color == 'blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-blue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-blue.svg";


                }
                if (this.color == 'rose') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-rose.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-rose.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-rose.svg";

                }
                if (this.color == 'lime') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-lime.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-lime.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-lime.svg";


                }
                if (this.color == 'coral') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Draeger/bullet-draeger-coral.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Draeger/external-draeger-coral.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Draeger/check-draeger-coral.svg";


                }

            }

            if (this.brandname == 'electrolux') {
                this.main_font = "'electrolux-sans-semibold'"
                this.second_font = "'electrolux-regular'";
                console.log(this.color)
                if (this.color == 'blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Electrolux/bullet-electrolux-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Electrolux/external-electrolux-blue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Electrolux/check-electrolux-blue.svg";
                }
                if (this.color == 'dark blue') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Electrolux/bullet-electrolux-dark-blue.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Electrolux/external-electrolux-dark-blue.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Electrolux/check-electrolux-dark-blue.svg";
                }
                if (this.color == 'gray') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Electrolux/bullet-electrolux-gray.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Electrolux/external-electrolux-gray.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Electrolux/check-electrolux-gray.svg";
                }
                if (this.color == 'brown') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Electrolux/bullet-electrolux-brown.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Electrolux/external-electrolux-brown.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Electrolux/check-electrolux-brown.svg";
                }
                if (this.color == 'green') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Electrolux/bullet-electrolux-green.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Electrolux/external-electrolux-green.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Electrolux/check-electrolux-green.svg";
                }
                if (this.color == 'wine') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Electrolux/bullet-electrolux-wine.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Electrolux/external-electrolux-wine.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Electrolux/check-electrolux-wine.svg";
                }
                if (this.color == 'mustard') {
                    this.bullet_back_src = "./assets/img/snippet/BrandElements/Electrolux/bullet-electrolux-mustard.svg";
                    this.link_back_src = "./assets/img/snippet/BrandElements/Electrolux/external-electrolux-mustard.svg" //give it to <a.external> tag
                    this.check_bac_src = "./assets/img/snippet/BrandElements/Electrolux/check-electrolux-mustard.svg";
                }
            }

            //ul {padding-left: 15px;}  ol {padding:0px} #subcontent ul li::before {content: " ";color:'+this.main_color+'!important;font-weight: bold;display: inline-block;width: 1em;margin-left: -1em;}
            this.left_column = this.domSanitizer.bypassSecurityTrustHtml(this.halfhalfdata['lc_introduction'] + '<style>#subcontent h1,h2,h3,h4,h5,h6{color:' + this.heading_font_color + '!important} #subcontent,#Content h1,h2,h3,h4,h5,h6{font-family:' + this.main_font + '} #subcontent ul {list-style-type: none;} ol {list-style-type:none}  #subcontent ol  li::before {content: counter(li); color: ' + this.heading_font_color + '!important; display: inline-block; width: 1em; margin-left: 0em ;font-size:32px; } #subcontent ol li {counter-increment: li}  .emphasized{color:' + this.heading_font_color + '} #subcontent ul,li,p,strong{font-family:' + this.second_font + '} #subcontent ul.list { width:auto; } #subcontent ul.list li { padding:0 0 0 25px; background:url("' + this.bullet_back_src + '") 0 ' + this.bullet_position_top + 'px no-repeat; list-style-type: none; } a.external { display: block;color:' + this.heading_font_color + '!important; line-height: 25px;float: left;background: url("' + this.link_back_src + '") 0 ' + this.bullet_position_top + 'px no-repeat !important;padding: 0 0 7px 21px !important; } ul.link-list li {width: 100%;overflow: hidden;}  ul.link-list li a { border-bottom: 0 !important;} ul.link-list li { width: 100%;overflow: hidden;} #subcontent ul.check-list { width:auto; } #subcontent ul.check-list li { padding:0 0 0 25px !important; background:url("' + this.check_bac_src + '") 0 3px no-repeat; list-style-type: none ; } #subcontent ul.small-ordered-list .ordered-number { color:' + this.heading_font_color + ';font-family:' + this.main_font + '!important} #subcontent ul.small-ordered-list .ordered-number { color:' + this.heading_font_color + ';font-family:' + this.main_font + '!important}  #subcontent ul.ordered-list .ordered-number {color:' + this.heading_font_color + ';font-family:' + this.main_font + '!important} #subcontent p {padding:0px 0px 18px} #Content .richtext div.media-block .capture {background-color:' + this.main_color + '} #Content .richtext div.media-block .capture p {color:black !important} #subcontent p {padding:0px 0px 18px} #subcontent span.highlighted {color:' + this.heading_font_color + '} #subcontent div.capture h3  {color:#ffffff !important} #subcontent a {color:' + this.heading_font_color + '!important;} .sub-bottom {border-bottom: 1px dotted ' + this.heading_font_color + '!important;}</style>');
            this.right_column = this.domSanitizer.bypassSecurityTrustHtml(this.halfhalfdata['rc_introduction'] + '<style>#maincontent h1,h2,h3,h4,h5,h6{color:' + this.heading_font_color + '!important} #maincontent,#Content h1,h2,h3,h4,h5,h6{font-family:' + this.main_font + '} #assignment ul { width:auto; } #assignment ul li { padding:0 0 0 25px !important; background:url("' + this.bullet_back_src + '") 0 ' + this.bullet_position_top + 'px no-repeat; list-style-type: none; }   #maincontent ul {list-style-type:none}  ol {list-style-type:none} ol {padding-left:0px;}   #maincontent ol  li::before {content: counter(li); color: ' + this.heading_font_color + '!important; display: inline-block; width: 1em; margin-left: 0em !important;font-size:32px; } #maincontent ol li {counter-increment: li}  .emphasized{color:' + this.heading_font_color + '} #maincontent ul,li,p,strong{font-family:' + this.second_font + '} #maincontent ul.list { width:auto; } #maincontent ul.list li { padding:0 0 0 25px ; background:url("' + this.bullet_back_src + '") 0 ' + this.bullet_position_top + 'px no-repeat; list-style-type: none ; } a.external { display: block;color:' + this.heading_font_color + '!important; line-height: 25px;float: left;background: url("' + this.link_back_src + '") 0 8px no-repeat !important;padding: 0 0 7px 21px !important; } ul.link-list li {width: 100%;overflow: hidden;}  ul.link-list li a { border-bottom: 0 !important;} ul.link-list li { width: 100%;overflow: hidden;} #maincontent ul.check-list { width:auto; } #maincontent ul.check-list li { padding:0 0 0 25px !important; background:url("' + this.check_bac_src + '") 0 3px no-repeat; list-style-type: none ; } #maincontent ul.small-ordered-list .ordered-number { color:' + this.heading_font_color + ';font-family:' + this.main_font + '!important}  #maincontent ul.ordered-list .ordered-number {color:' + this.heading_font_color + ';font-family:' + this.main_font + '!important} #maincontent p {padding:0px 0px 25px}  #maincontent span.highlighted {color:' + this.heading_font_color + '} #maincontent div.capture h3  {color:#000 !important} #maincontent a {color:' + this.heading_font_color + '!important;} .main-bottom {border-bottom: 1px dotted ' + this.heading_font_color + '!important;} .white-bottom {border-bottom: 1px dotted #ffffff !important;} </style>');

            this.visual_position = this.halfhalfdata['pwv_postion'];
            this.visualimage = this.halfhalfdata['pwv_visual_image'];
            this.backgrd_position = this.halfhalfdata['bi_position'];
            if (this.backgrd_position == 'left') {
                this.backgrdimagposition = 'left bottom'
            }
            if (this.backgrd_position == 'right') {
                this.backgrdimagposition = 'right bottom'
            }
            this.bacgrdimage = this.halfhalfdata['background_image'];
            if (this.bacgrdimage) {
                this.forbackimg = this.domSanitizer.bypassSecurityTrustHtml('<style> .half-back-img {background:' + 'url' + '(' + this.imgurl + this.bacgrdimage + ')' + 'no-repeat' + ';background-position:' + this.backgrdimagposition + '}</style>')
            }

            if (this.halfhalfdata.sub_title) {
                this.subtitle = this.halfhalfdata.sub_title
            }


            if (this.is_service_note == '0') {
                this.showNotes()
                this.getNotes()
            }

            ///assignment and learning goals
            if (this.halfhalfdata.assignment_id) {
                this.assignment_name = this.halfhalfdata.assignment_name
                this.showassignment = true
                this.allow_upload = this.halfhalfdata.allow_upload            //if == 1
                this.assign_type = this.halfhalfdata.indi_or_team             //if ==1 individual else team
                this.assignmentdata = this.halfhalfdata.assignment_data
                if (this.assignmentdata['0'].learning_goaldata) {
                    this.learninggoals = this.assignmentdata['0'].learning_goaldata
                }
                if (this.assign_type == '2') {
                    if (this.assignmentdata['0'].teamdata) {

                        let teamalldata: any[] = []
                        let storeteamdata: any[] = []
                        teamalldata = this.assignmentdata['0'].teamdata

                        for (let i = 0; i < teamalldata.length; i++) {
                            if (this.user_slug === teamalldata[i].user_slug) {
                                this.teamid = teamalldata[i].as_tid
                            }
                        }
                        for (let i = 0; i < this.teamsvalue.length; i++) {
                            storeteamdata.push(teamalldata.filter(v => v.as_tid === this.teamsvalue[i]))
                        }
                        this.teamdata = storeteamdata.filter(value => Object.keys(value).length !== 0)

                        this.assignmentid = this.halfhalfdata.assignment_id
                    }
                }
                if (this.showassignment) {
                    this.assignmentShow()
                    this.getResults()
                    this.getUpload()
                }
            }

        }, (error) => {
            console.log(error);
        });
    }

    getResults() {
        this.result.emit({
            aid: this.assignmentid,
            pid: this.id,
            type: this.assign_type,
            tid: this.teamid,
            aname: this.assignment_name
        })
    }

    getUpload() {
        this.upload.emit({
            aid: this.assignmentid,
            pid: this.id,
            type: this.assign_type,
            tid: this.teamid,
            aname: this.assignment_name
        })
    }


    showNotes() {
        this.notesicon.emit({
            isnoteallowed: this.is_service_note,
            notes_access: this.user_access.isaddnote,
            notification: this.notification
        })
    }


    assignmentShow() {
        this.assignment.emit({
            show_assign: this.showassignment,
            allow_uplaod: this.allow_upload,
            access: this.user_access.isuploadassignments
        })
    }

    getNotes() {
        this.notes.emit(this.id)
    }

    thumbnailVideoImage(type, index, v, check, enlarge_img) {
        console.log(type, index, v, check)
        // $('.main-display ').empty()
        if (check == 'both') {
            $('.both').empty();
            if (type == "img") {

                $('#bothvideothumbnailsrc').remove();
                $('.both').append("<a id=\"enlargeimg\"  class=\"enlarge\" data-backdrop=\"static\" data-keyboard=\"false\" data-target=\"#enlargeimgmodal\" data-toggle=\"modal\" onclick=\"Window.myComponent.getEnlargeImage('" + enlarge_img + "')\">enlarge</a>");
                // $('.both').append("<img id=\"bothimagethumbnailsrc\"  src=\"" + v + "\" alt=\"\" height=\"362\" width=\"648\" />");
                $('.both').append("<img id=\"bothimagethumbnailsrc\"  src=\"" + v + "\" alt=\"\"  />");
            }

            if (type == "external-video") {

                $('#enlargeimg').remove();
                $('#bothimagethumbnailsrc').remove();
                // $('.both').append("<iframe id=\"bothvideothumbnailsrc\"  width=\"648\" height=\"362\" src=\"" + v + "\" frameborder=\"0\" allowfullscreen></iframe>");
                $('.both').append("<iframe id=\"bothvideothumbnailsrc\"   src=\"" + v + "\" frameborder=\"0\" allowfullscreen></iframe>");
            }

            $('img').parent().parent().find("li").removeClass("active");
            $('img').parent().addClass("active");

            $('.capture').find("div").hide();
            $('.capture').find('div').removeClass('hide')
            $('.capture').find(".capture" + index).show();
        }
        if (check == 'singlevideo') {

            $('.singlevideo').empty();
            $('#videothumbnailsrc').remove();
            // $('.singlevideo').append("<iframe id=\"videothumbnailsrc\"  width=\"648\" height=\"362\" src=\"" + v + "\" frameborder=\"0\" allowfullscreen></>");
            $('.singlevideo').append("<iframe id=\"videothumbnailsrc\"   src=\"" + v + "\" frameborder=\"0\" allowfullscreen></>");
            $('img').parent().parent().find("li").removeClass("active");
            $('img').parent().addClass("active");

            $('.capture').find("div").hide();
            $('.capture').find('div').removeClass('hide')
            $('.capture').find(".capture" + index).show();
        }
        if (check == 'singleimage') {
            $('.singleimage').empty();
            $('#imagethumbnailsrc').remove();
            // $('.singleimage').append("<img id=\"imagethumbnailsrc\"  src=\"" + v + "\" alt=\"\" height=\"362\" width=\"648\" />" removed height and width for selectable media snippet.);
            $('.singleimage').append("<img id=\"imagethumbnailsrc\"  src=\"" + v + "\" alt=\"\"  />");
            $('img').parent().parent().find("li").removeClass("active");
            $('img').parent().addClass("active");

            $('.capture').find("div").hide();
            $('.capture').find('div').removeClass('hide')
            $('.capture').find(".capture" + index).show();
        }


    }


    getEnlargeImage(v) {
        this.shareservice.enLargeImagePath(v)
    }

}

export interface halfhalfdata {
    differentpage: any[];
    page: any[];
    notification: any;
}